module.exports = __webpack_public_path__ + "img/alert-blue.36ab6871.svg";